import {GradientDefaultBox} from './gradient.default.box';

export const GradientBox = GradientDefaultBox;